import { deleteData, getData, putData, postData } from './request';
import type {
  MaterialRequest,
  MaterialRequestForm,
  MaterialRequestLabel,
} from '@cutr/constants/material-request';

export type MaterialRequestRow = MaterialRequest & {
  id: string;
  orderVariantId: string;
};

export async function getMaterialRequests(
  variantId: string,
  signal?: AbortSignal
) {
  return getData<MaterialRequestRow[]>(
    `/v2/order-variants/${variantId}/material-requests`,
    { signal }
  );
}

export async function createMaterialRequest(
  data: Omit<MaterialRequestForm, 'id'>
) {
  return postData<MaterialRequestRow>('/v2/material-requests', data);
}

export async function updateMaterialRequest(data: MaterialRequestForm) {
  return postData<MaterialRequestRow>(`/v2/material-requests/${data.id}`, data);
}

export async function deleteMaterialRequest(id: MaterialRequest['id']) {
  return deleteData<void>(`/v2/material-requests/${id}`);
}

export async function updateMaterialRequestLabel(
  id: MaterialRequest['id'],
  data: MaterialRequestLabel
) {
  return putData<void>(`/v2/material-requests/${id}/label`, data);
}
